import { useEffect, useState } from "react";
import { Badge, Button, Col, Form, Label, Row } from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  PreviewAltCard,
} from "../../components/Component";

import { toast } from "react-toastify";
import { BASE_URL_IMG } from "../../assets/constants";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";

import Status from "../../MyComp/UI/form/Status";
import MyButton from "../../MyComp/UI/form/MyButton";
import MyDataTable from "../../MyComp/UI/DataTable/MyDataTable";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import { useForm } from "react-hook-form";
import ImageUpload from "../ImageFolder/ImageUpload";
import { departmentCategoryDropDown } from "../../api/dropdown";
import { hospitalDepartmentList } from "../../api/Hospital";
import { addSpecialization } from "../../api/Hospital";
import { SpecializationList } from "../../api/Hospital";
import { UpdateHospitalServices } from "../../api/Hospital";

import {
  createDiseaseAPI,
  createGroupAPI,
  createLabTest,
  createPackageTestAPI,
  createSubGroupAPI,
  deleteLabTest,
  deletePackageTest,
  deleteTestCategory,
  deleteTestSubCategory,
  getTestListsAPI,
  listDiseaseAPI,
  listGroupAPI,
  listPackageAPI,
  listSubGroupAPI,
  updateDiseaseAPI,
  updateGroupAPI,
  updateLabTestAPI,
  updatePackageTestAPI,
  updateSubGroupAPI,
} from "../../api/master/indes";

import MyInput from "../../MyComp/UI/form/MyInput";
import ViewImgAndPdf from "../ImageFolder/ViewImageAndPdf";
import useLogout from "../../hooks/useLogout";
import { UserAvatarCell } from "../../MyComp/ImageView/UserAvatarCell";
import {
  categoryDDAPI,
  categoryPackageDDAPI,
  categoryTestDDAPI,
  generateFileAPI,
  groupDDAPI,
  subCategoryDDAPI,
  testDDAPI,
} from "../../api/dropdown";
import MySelect from "../../MyComp/UI/form/MySelect";
import DeleteModal from "../../MyComp/UI/modals/DeleteModal";
import ApiPaginationDataTable from "../../MyComp/UI/DataTable/ApiPaginationDataTable";
import DiscountValidation from "../../MyComp/UI/form/DiscountValidation";
import MyTextArea from "../../MyComp/UI/form/MyTextArea";
import MyMobile from "../../MyComp/UI/form/MyMobile";
import { addHospitalDepartment } from "../../api/Hospital";
import { updateDepartmentStatus } from "../../api/Hospital";
import { updateDepartment } from "../../api/Hospital";
import { departmentDropDownList } from "../../api/Hospital";
import { updateSpecialization } from "../../api/Hospital";

const Hospital = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    clearErrors,
    getValues,
    setError,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: true,
      addSub: false,
      data: [],
    },
  });
  const logout = useLogout();
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState("Add");
  const [loading, setLoading] = useState(false);

  const data = watch("data");
  const [tableData, setTableData] = useState([]);
  const [imageOpen, setImageOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isEditing, setIsEditing] = useState(false);
  const [totalRows, setTotalRows] = useState(1);
  const [perPage, setPerPage] = useState(25);

  const [itemPerPage, setItemPerPage] = useState(25);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [categoryOptions, setCategoryOptions] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [departments, setDepartments] = useState([]);

  const columns = [
    {
      name: "Image",
      selector: (row) => (
        <div onClick={() => row?.image && handleImageOpenPreview(`${BASE_URL_IMG}${row.image}`)} style={{ cursor: row?.image ? "pointer" : "default" }}>
          <UserAvatarCell
            row={row}
            name={row?.name}
            handleImageOpenPreview={handleImageOpenPreview}
            image={row?.image ? `${BASE_URL_IMG}${row.image}` : undefined}
          />
        </div>
      ),
      sortable: false,
      wrap: true,
    },
    // {
    //   name: "Department Id",
    //   selector: (row) => row?.departmentName || " ",
    //   sortable: true,
    //   wrap: true,
    // },

    {
      name: "Name",
      selector: (row) => row?.name || "-",
      sortable: true,
      wrap: true,
    },
    {
      name: "Description",
      selector: (row) => row?.description || "-",
      sortable: true,
      wrap: true,
    },

    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge color={row.status ? "success" : "danger"}>{row.status ? "Active" : "Inactive"}</Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
      //   width: "90px",
    },

    {
      name: "Action",
      wrap: true,
      width: "120px",
      cell: (row) => (
        <div>
          <Button outline color="warning" size="xs" className="me-1" onClick={() => handleEdit(row)}>
            <Icon name="edit" />
          </Button>
          {/* <Button outline color="danger" size="xs" onClick={() => handleDeleteClick(row)}>
            <Icon name="trash" />
          </Button> */}
        </div>
      ),
    },
  ];
  useEffect(() => {
    serverSideSearch();
  }, [perPage, currentPage]);

  const serverSideSearch = () => {
    const body = {
      search: watch("server_search"),
      page: currentPage,
      limit: perPage,
    };

    setLoading(true);

    SpecializationList(body)
      .then((res) => {
        if (res.data.status === true) {
          const list = (res?.data?.data || []).map((item) => ({
            id: item?.id,
            department_id: item?.departmentId,
            departmentName: item?.departmentName,
            name: item?.name,
            description: item?.description,
            image: item?.image,
            status: item.status,
          }));

          setTableData(list);
          setTotalRows(res?.data?.data?.totalDepartment || 0);
          setValue("limit", res?.data?.data?.totalDepartment || 0);
        } else if (res.data.status === false) {
          setTableData([]);
        } else if (res.data.status === "expired") {
          logout();
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handlePerRowsChange = (newPerPage, page) => {
    const rows = isNaN(newPerPage) ? totalRows : newPerPage;
    setPerPage(rows);
    setValue("page", page);
    console.log("rows", page, rows);
  };
  const handlePageChange = (page) => {
    console.log("page", page);
    setPerPage(perPage);
    setCurrentPage(page);
    setValue("page", page);
  };
  // Fetch group list

  const onFormSubmit = async (formData) => {
    try {
      setIsLoading(true);

      const payload = new FormData();
      payload.append("id", watch("selectedRow")?.id || "");
      payload.append("departmentId", formData?.test?.value || "");
      payload.append("name", formData?.name || "");
      payload.append("description", formData?.Description || "");
      // Keep status format consistent with other master endpoints (boolean -> string 'true'/'false')
      payload.append("status", formData?.status?.value ?? "");

      if (formData?.department_img instanceof File) {
        payload.append("image", formData.department_img);
      }

      let res;

      if (mode === "Edit") {
        res = await UpdateHospitalServices(payload);
      } else {
        res = await addSpecialization(payload);
      }

      if (res?.data?.status === true) {
        toast.success(res.data.message);
        reset();
        setIsOpen(false);
        serverSideSearch(); // 🔥 refresh table
      } else if (res?.data?.status === "expired") {
        logout();
      } else {
        toast.error(res?.data?.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  const handleEdit = async (row) => {
    window.scrollTo(0, 0);

    setMode("Edit");
    setIsOpen(true);
    resetF();
    setValue("selectedRow", row);

    const selectedDept = departments.find((item) => item.value === row.department_id);
    setValue("test", selectedDept || null);
    setValue("name", row.name || "");
    setValue("Description", row.description || "");

    const imageUrl = row?.image ? `${BASE_URL_IMG}${row.image}` : null;
    setValue("department_image", imageUrl);
    setValue("department_img", imageUrl);

    setValue("status", {
      label: row.status ? "Active" : "InActive",
      value: !!row.status,
    });
  };

  const handleToggleStatus = (row) => {
    setValue("selectedRow", row);
    setShowModal(true);
  };

  const confirmStatusChange = async () => {
    const selected = watch("selectedRow");

    const formObject = {
      id: selected?.id,
      // other master endpoints expect 'true'/'false' strings (from boolean values)
      status: selected?.status ? "false" : "true",
    };

    setValue("isLoading", true);

    try {
      const res = await updateDepartmentStatus(formObject); // ✅ CORRECT API

      if (res.data.status === true) {
        toast.success(res.data.message);
        serverSideSearch(); // 🔥 refresh table
      } else if (res.data.status === "expired") {
        logout();
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message);
    } finally {
      setValue("isLoading", false);
      setShowModal(false);
    }
  };

  const handleImageOpenPreview = (row) => {
    // const imageUrl = `${BASE_URL_IMG}${row?.image}`;
    setValue("image_preview", row);
    setImageOpen(true);
  };

  const handleSubdiseaseClick = (row) => {
    window.scrollTo(0, 0);
    setIsOpen(true);
    setMode("Add");
    setValue("addSub", true);
    setValue("selectedRow", row);
    setValue("group", row?.name);
    setValue("group_image", row.image);
    setValue("group_img", row.image);
    setValue("status", {
      label: row.status ? "Active" : "Inactive",
      value: row.status,
    });
  };

  const handleImageClose = () => {
    setImageOpen(false);
  };

  const truncateByCharacters = (text = "", charLimit = 20) => {
    if (!text) return "";

    return text.length > charLimit ? text.slice(0, charLimit) + "..." : text;
  };
  const discountType = [
    { value: "percentage", label: "percentage" },
    {
      value: "fixed",
      label: "fixed",
    },
  ];
  const resetF = () => {
    setValue("mrp", null);
    setValue("discount", null);
    setValue("discountType", null);
    setValue("test", null);
    setValue("status", null);
    setValue("subcategory", null);
    setValue("category", null);
    setValue("address", null);
    setValue("contact_number", null);
    setValue("operating_hours", null);
    setValue("Description", null);
    setValue("department_img", null);
    setValue("department_image", null);
    setValue("department_img_type", null);
    setValue("group_img", null);
    setValue("net", null);
    setValue("discount_type", null);
    setValue("price", null);
    // trigger();
    clearErrors();
    // trigger(["price"])
  };
  const generateFile = () => {
    // const body = { categoryId };

    generateFileAPI()
      .then((res) => {
        console.log(res.data, "res.fileee");
        if (res.data.status === true) {
          // setValue("subCategoryDD", res.data.data);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          // setValue("subCategoryDD", []);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };
  useEffect(() => {
    const price = watch("price");
    const discount = watch("discount");
    const discountType = watch("discount_type");

    if (price && discount && discountType) {
      let netPrice = parseFloat(price);
      const discountValue = parseFloat(discount);

      if (discountType.value === "percentage") {
        netPrice = price - price * (discountValue / 100);
      } else if (discountType.value === "fixed") {
        netPrice = price - discountValue;
      }

      netPrice = Math.max(0, netPrice);

      setValue("net", netPrice.toFixed(2));

      trigger("net");
      trigger("price");
      // trigger("discount")
    } else {
      setValue("net", "");
      //  setValue("discount", "");
      //  setValue("discount_type", "");
    }
  }, [watch("price"), watch("discount"), watch("discount_type")]);

  useEffect(() => {
    getDepartments();
  }, []);

  const getDepartments = async () => {
    try {
      const res = await departmentDropDownList({});

      if (res?.data?.status === true) {
        setDepartments(res?.data?.data || []); // ✅ DIRECT USE
      }
    } catch (error) {
      console.error(error);
    }
  };


  return (
    <>
      <Head title=" Hospital Services | Master" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                Manage Services
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent className={"me-2 mt-4"}>
              <div className="me-2 d-flex g-5">
                <Button
                  color="primary"
                  outline
                  className="me-n1  mx-2"
                  onClick={() => {
                    setIsOpen((pre) => !pre);
                    setMode("Add");
                    resetF();
                  }}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          {isOpen && (
            <PreviewAltCard>
              <Form onSubmit={handleSubmit(onFormSubmit)}>
                <Row>     
                  <Col xs="12" sm="6" md="4" lg="3">
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Services Name"
                      name="test"
                      placeholder="Enter Services name"
                      required
                      options={departments}
                    />
                  </Col>
                   <Col xs="12" sm="6" md="4" lg="3">
                    <ImageUpload
                      name="department_img"
                      id="department_image"
                      watch={watch}
                      label="Upload Services Image"
                      errors={errors}
                      register={register}
                      trigger={trigger}
                      clearErrors={clearErrors}
                      image="department_img"
                      image_url="department_image"
                      setValue={setValue}
                      handleImageOpenPreview={handleImageOpenPreview}
                      required
                      getValues={getValues}
                    />
                  </Col>
                  <Col xs="12" sm="6" md="4" lg="3">
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Name"
                      name="name"
                      placeholder="Enter name"
                      required
                    />
                  </Col>

                  <Col xs="12" sm="6" md="4" lg="3">
                    <Status
                      title="Status"
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                    />
                  </Col>
                  <Col md="12">
                    <MyTextArea
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Description"
                      name="Description"
                      placeholder="Tell us something about department"
                    />
                  </Col>

                  <Col xs="12" sm="6" md="3" lg="3">
                    <MyButton isLoading={isLoading} mode={mode} />
                  </Col>
                </Row>
              </Form>
            </PreviewAltCard>
          )}
          <div style={{ overflowX: "auto" }}>
          <ApiPaginationDataTable
            resetF={resetF}
            // generateFile={generateFile}
            columns={columns}
            data={tableData}
            title={"Services List"}
            isLoading={loading}
            register={register}
            trigger={trigger}
            watch={watch}
            setValue={setValue}
            errors={errors}
            totalRows={watch("limit")}
            perPage={watch("perPage")}
            serverSearch
            paginationServer
            serverSideSearch={serverSideSearch}
            handlePageChange={handlePageChange}
            handlePerRowsChange={handlePerRowsChange}
          />
          </div>
        </Block>
      </Content>

      <ConfirmModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
      />

      <ViewImgAndPdf url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
    </>
  );
};

export default Hospital;
